import React, { Component } from 'react';

import Content from 'components/Content';
import Menu from 'components/Menu';

class DefaultLayout extends Component {
  state = {
    menuVisible: false,
  };
  toggleMenu = isVisible =>
    this.setState({
      menuVisible: isVisible !== undefined ? isVisible : !this.state.menuVisible,
    });
  render() {
    return (
      <div className="DefaultLayout">
        <Menu toggleMenu={menuState => this.toggleMenu(menuState)} />
        <Content
          className="Site__content"
          menuVisible={this.state.menuVisible}
          toggleMenu={menuState => this.toggleMenu(menuState)}
        >
          {this.props.children}
        </Content>
      </div>
    );
  }
}

export default DefaultLayout;



// WEBPACK FOOTER //
// ./src/layouts/DefaultLayout.js